export const SET_BANNER_FIRST_TIME='SET_BANNER_FIRST_TIME'